/** @jsxImportSource @emotion/react */
import { lazy, Suspense } from 'react';
import { Navigate, Route } from 'react-router-dom';
import Loader from '../../../../../../shared/components/molecules/loader';
import { LOADING } from '../../../../../../shared/constants';
import { ChatWindowSourcePage } from '../../../typings';
import ConversationRedirect from '../redirectChatID';
import { ROUTES } from '../../../../../../shared/constants/routes';

const HomeCenterLazyComponent = lazy(() => import('..'));

const ConversationsLazyComponent = lazy(() => import('../../../../../conversations/v1'));

const WAGroupLazyComponent = lazy(() => import('../../../../../wa-groups'));

export default function getRoutesV1({ isEmbed }: { isEmbed?: boolean }) {
  if (isEmbed) {
    return [
      <Route
        key="/"
        path="/"
        element={
          <Suspense fallback={<Loader size={32} secondary={LOADING} />}>
            <ConversationsLazyComponent srcPage={ChatWindowSourcePage.CHAT} />
          </Suspense>
        }
      />,
    ];
  }

  return [
    <Route
      key={`/:chatId`}
      path={`/:chatId`}
      element={
        <Suspense fallback={<Loader size={32} secondary={LOADING} />}>
          <ConversationRedirect />
        </Suspense>
      }
    />,
    <Route
      key={ROUTES.WA_GROUP}
      path={ROUTES.WA_GROUP}
      element={
        <Suspense fallback={<Loader size={32} secondary={LOADING} />}>
          <WAGroupLazyComponent />
        </Suspense>
      }
    />,
    <Route
      key={`/:integrationWabaNumber/:id`}
      path={`/:integrationWabaNumber/:id`}
      element={
        <Suspense fallback={<Loader size={32} secondary={LOADING} />}>
          <ConversationsLazyComponent srcPage={ChatWindowSourcePage.CHAT} />
        </Suspense>
      }
    >
      <Route
        path=":messageId"
        element={
          <Suspense fallback={<Loader size={32} secondary={LOADING} />}>
            <ConversationsLazyComponent srcPage={ChatWindowSourcePage.CHAT} />
          </Suspense>
        }
      />
    </Route>,
    <Route
      key="/"
      path="/"
      element={
        <Suspense fallback={<Loader size={32} secondary={LOADING} />}>
          <HomeCenterLazyComponent />
        </Suspense>
      }
    />,
    <Route key="*" path="*" element={<Navigate to={'/'} replace />} />,
  ];
}
